import { createContext, useContext, type ButtonHTMLAttributes, type ReactNode } from 'react'
import { useApi, useAsync } from '../lib/useApi.js'

const Permissions = createContext<readonly string[] | null>(null)

/** UI affordance only. Every request remains authorized by the server. */
export function PermissionsProvider({ children }: { children: ReactNode }) {
  const api = useApi()
  const state = useAsync(() => api.me(), [api])
  return (
    <Permissions.Provider value={state.loading || state.error ? null : (state.data?.permissions ?? null)}>
      {state.error && (
        <p className="error" role="alert">
          Could not load your permissions. Restricted actions are disabled.{' '}
          <button className="btn" onClick={state.reload}>
            Retry permissions
          </button>
        </p>
      )}
      {children}
    </Permissions.Provider>
  )
}

export function PermissionButton({
  permission,
  disabled,
  title,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { permission: string }) {
  const permissions = useContext(Permissions)
  const allowed = permissions?.includes(permission) ?? false
  return (
    <button
      {...props}
      disabled={disabled || !allowed}
      title={
        !allowed ? (permissions ? `Your role does not allow ${permission}.` : 'Checking permissions…') : title
      }
    />
  )
}
